export default __webpack_public_path__ + "static/media/agriculturaOrganica.f86e719c.jpg";